import service from '@/services/construction/ConstructionService'

export const constructionModule = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    constructionList: [],
    tipoList: [],
    tipoEdificacaoList: [],
    statusList: [],
    origemClienteList: [],
    loadingItems: false,
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
    },
  },
  mutations: {
    SET_LIST(state, payload) {
      if (payload.current_page) {
        state.pagination.current_page = payload.current_page
        state.pagination.last_page = payload.last_page
      }
      state.constructionList = payload.data ?? payload
    },
    SET_COMPONENTS_LIST(state, payload) {
      state.tipoList = payload.componentes.tipo
      state.tipoEdificacaoList = payload.componentes.tipoEdificacao
      state.statusList = payload.componentes.status
      state.origemClienteList = payload.componentes.origem
    },
    SET_LOADING(state) {
      state.loadingItems = !state.loadingItems
    },
  },
  actions: {
    async getComponents({ commit }) {
      const responseComponents = await service.createConstruction()
      commit('SET_COMPONENTS_LIST', responseComponents)
    },
    async getConstructions({ commit }, payload) {
      try {
        commit('SET_LOADING')
        let response = await service.getConstructions(payload)
        await commit('SET_LIST', response)
      } finally {
        commit('SET_LOADING')
      }
    },

    async getConstruction({ commit }, payload) {
      let data = await service.getConstruction(payload)
      await commit('SET_COMPONENTS_LIST', data)

      return data.obra
    },

    async insertConstruction({ dispatch, state }, payload) {
      let request = service.translateToFirebird(payload)
      const { status } = await service.insert(request)

      dispatch('getConstructions', {
        page: state.pagination.current_page,
      })
      return status
    },

    async updateConstruction({ dispatch, state }, payload) {
      let request = service.translateToFirebird(payload)
      const { status } = await service.update(request, payload.id)

      dispatch('getConstructions', {
        page: state.pagination.current_page,
      })

      return status
    },

    async deleteConstruction({ dispatch, state }, payload) {
      const { status } = await service.delete(payload)

      dispatch('getConstructions', {
        page: state.pagination.current_page,
      })

      return status
    },
  },

  getters: {
    getComboBoxList: (state) => {
      let comboBox = state.constructionList.map((construction) => {
        return {
          codigo: construction.CODIGO,
          descricao: construction.CODIGO + ' - ' + construction.NOME,
        }
      })
      return comboBox
    },
    getComboBoxTipoList: (state) => {
      let comboBox = Object.entries(state.tipoList)
      comboBox = comboBox.map((tipo) => {
        return {
          value: tipo[0],
          text: tipo[1],
        }
      })
      return comboBox
    },
    getComboBoxOrigemClienteList: (state) => {
      let comboBox = Object.entries(state.origemClienteList)
      comboBox = comboBox.map((tipo) => {
        return {
          value: tipo[0],
          text: tipo[1],
        }
      })
      return comboBox
    },
    getComboBoxStatusList: (state) => {
      let comboBox = Object.entries(state.statusList)
      comboBox = comboBox.map((tipo) => {
        return {
          value: tipo[0],
          text: tipo[1],
        }
      })
      return comboBox
    },
    getComboBoxTipoEdificacaoList: (state) => {
      let comboBox = Object.entries(state.tipoEdificacaoList)
      comboBox = comboBox.map((tipo) => {
        return {
          value: tipo[0],
          text: tipo[1],
        }
      })
      return comboBox
    },
  },
}
